<template>
  <div class="index-hot-product container-md" v-if="productList && productList.length">
    <div class="title-box">
      <div class="left-box">
         <div class="title">常办签商品</div>
      </div>
      <div class="right-box">
      </div>
    </div>
    <div class="content">
      <div class="product-list">
        <router-link
          v-for="product in productList"
          :key="product.visa_product_id"
          class="product-item"
          :to="goProduct(product)"
        >
          <div class="product-item-type" :class="visaTypeClassMap[product.visa_type] ? visaTypeClassMap[product.visa_type].className: visaTypeClassMap['qita'].className">
            <img class="icon" :src="visaTypeClassMap[product.visa_type] ? visaTypeClassMap[product.visa_type].imageUrl: visaTypeClassMap['qita'].imageUrl" alt="">
            <span class="text">{{ product.visa_type }}</span>
          </div>
          <div class="product-item-info">
            <div class="product-item-info-left">
              <div class="product-item-title">{{product.product_name}}</div>
              <div class="product-item-other">
                <div class="product-item-depart-date">最早可选出行时间: {{product.earliest_depart_date_cn}}</div>
                <div class="product-item-info-need-days" v-if="product.need_days_shortest === product.need_days_longest">预计办理&nbsp;{{ product.need_days_shortest }}&nbsp;工作日</div>
                <div class="product-item-info-need-days" v-else>预计办理&nbsp;{{ product.need_days_shortest }}-{{ product.need_days_longest }}&nbsp;工作日</div>
                <div class="product-item-entry-count">
                  入境次数: {{product.entry_count}}
                  <el-tooltip
                    class="tips"
                    effect="dark"
                    :content="product.entry_count_memo"
                    placement="top"
                    popper-class="m-w-400"
                    v-if="product.entry_count_memo">
                    <img src="../../../assets/imgs/homepage/question.png" />
                  </el-tooltip>
                </div>
                <div class="product-item-validity-period">
                  有效期: {{ product.validity_period }}
                  <el-tooltip
                    class="tips"
                    effect="dark"
                    :content="product.validity_period_memo"
                    placement="top"
                    popper-class="m-w-400"
                    v-if="product.validity_period_memo">
                    <img src="../../../assets/imgs/homepage/question.png" />
                  </el-tooltip>
                </div>
                <div class="product-item-entry-stay">
                  停留时长: {{product.stay_duration}}
                  <el-tooltip
                    class="tips"
                    effect="dark"
                    :content="product.stay_duration_memo"
                    placement="top"
                    popper-class="m-w-400"
                    v-if="product.stay_duration_memo">
                    <img src="../../../assets/imgs/homepage/question.png" />
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="product-item-price-box">
              <div class="sale-price">
                <div class="symbol">￥</div>
                <div class="price">{{product.special_price ? product.special_price/100 : product.peer_price/100}}</div>
                <div class="special-label" v-if="product.special_price">
                  <img src="https://o.666visa.cn/static/ssqpeer/homepage/icon-special-left.png" alt="">
                </div>
              </div>
              <div class="original-price" v-if="product.special_price">
                原价<span class="price">￥{{product.peer_price/100}}</span>
              </div>
            </div>
          </div>

        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import tripUrl from '../../../assets/imgs/homepage/trip.png';
import businessUrl from '../../../assets/imgs/homepage/business.png';
import visitFriendsUrl from '../../../assets/imgs/homepage/visit-friends.png';
import shortTermStudyUrl from '../../../assets/imgs/homepage/short-term-study.png';
import medicalUrl from '../../../assets/imgs/homepage/medical-visa.png';
import accessUrl from '../../../assets/imgs/homepage/access-visa.png';
import defaultUrl from '../../../assets/imgs/homepage/default-product-type.png';
import Http from '../../../libs/http';
import sensorService from '../../../services/sensor-service';


export default {
  name: 'index-hot-product',
  props: {
  },
  data() {
    return {
      productList: [],
      visaTypeClassMap: {
        旅游签: { className: 'blue', imageUrl: tripUrl },
        商务签: { className: 'green', imageUrl: businessUrl },
        探亲访友签: { className: 'purple', imageUrl: visitFriendsUrl },
        短期学习签: { className: 'red', imageUrl: shortTermStudyUrl },
        医疗签: { className: 'yellow', imageUrl: medicalUrl },
        访问签: { className: 'light-blue', imageUrl: accessUrl },
        免签: { className: 'orange', imageUrl: defaultUrl },
        落地签: { className: 'pink', imageUrl: defaultUrl },
        过境签: { className: 'light-green', imageUrl: defaultUrl },
        香港L签过关服务: { className: 'deep-green', imageUrl: defaultUrl },
        入台证: { className: 'deep-purple', imageUrl: defaultUrl },
        展会签: { className: 'deep-yellow', imageUrl: defaultUrl },
        EVUS登记: { className: 'orange', imageUrl: defaultUrl },
        公证认证: { className: 'pink', imageUrl: defaultUrl },
        公证: { className: 'light-green', imageUrl: defaultUrl },
        签注续签: { className: 'deep-green', imageUrl: defaultUrl },
        '国际驾照（KIDA）': { className: 'deep-purple', imageUrl: defaultUrl },
        香港驾照: { className: 'deep-yellow', imageUrl: defaultUrl },
        入金证: { className: 'orange', imageUrl: defaultUrl },
        香港签注续签: { className: 'pink', imageUrl: defaultUrl },
        qita: { className: 'pink', imageUrl: defaultUrl }, // 此处故意用英文区分
      },
    };
  },
  created() {
    Http.post('/latest_order_product_query', {}).then((res) => {
      res.product_list.forEach((item) => {
        item.earliest_depart_date_cn = moment(item.earliest_depart_date).format('YYYY年MM月DD日');
      });
      this.productList = res.product_list;
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
  activated() {
    Http.post('/latest_order_product_query', {}).then((res) => {
      res.product_list.forEach((item) => {
        item.earliest_depart_date_cn = moment(item.earliest_depart_date).format('YYYY年MM月DD日');
      });
      this.productList = res.product_list;
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
  methods: {
    // 获取路由跳转地址
    goProduct(product) {
      const query = sensorService.getPageFrom('首页-常办签商品');
      return { name: 'product', params: { visa_product_id: product.visa_product_id }, query };
    },
  },
};
</script>
<style lang="less" scoped>
.index-hot-product{
  padding-bottom: 48px;
  .title-box{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .left-box{
      flex-grow: 1;
      display: flex;
      align-items: baseline;
      .title{
        font-size: 28px;
        line-height: 40px;
        color: #2F333D;
        font-weight: 600;
        position: relative;
        z-index: 1;
        &::after{
          content: "";
          width:96px;
          height:8px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,1) 100%);
          opacity:0.6;
          position: absolute;
          bottom: 2px;
          left: 0;
          z-index: -1;
        }
      }
      .sub-title{
        margin-left: 16px;
        color: #91999F;
        font-size: 18px;
      }
    }
    .right-box{
      flex-shrink: 0;
    }
  }
  .content{
    .product-list{
      .product-item{
        display: flex;
        height: 86px;
        margin-bottom: 24px;
        cursor: pointer;
        transition: all 0.2s;
        &:last-child{
          margin-bottom: 0;
        }
        &:hover{
          transform: translateY(-2px);
          box-shadow:0px 4px 8px 0px rgba(47,51,61,0.06);
          .product-item-title{
            color: #599FFF !important;
          }
        }
        .product-item-type{
          flex-shrink: 0;
          position: relative;
          width: 144px;
          flex-shrink: 0;
          height: 100%;
          background-size: 100% 100%;
          border-radius:2px 0 0 2px;
          padding-left: 16px;
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 20px;
          font-weight: 600;
          &.blue {
            background:linear-gradient(135deg,rgba(123,179,242,1) 0%,rgba(84,148,221,1) 100%);
          }
          &.green {
            background:linear-gradient(135deg,rgba(94,211,187,1) 0%,rgba(61,187,162,1) 100%);
          }
          &.purple {
            background:linear-gradient(135deg,rgba(161,154,223,1) 0%,rgba(130,122,202,1) 100%);
          }
          &.red {
            background:linear-gradient(135deg,rgba(251,143,143,1) 0%,rgba(240,99,99,1) 100%);
          }
          &.yellow {
            background:linear-gradient(135deg,rgba(238,214,104,1) 0%,rgba(237,184,80,1) 100%);
          }
          &.light-blue {
            background:linear-gradient(135deg,rgba(116,208,247,1) 0%,rgba(72,185,233,1) 99%);
          }
          &.orange {
            background:linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%);
          }
          &.pink {
            background:linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%);
          }
          &.light-green {
            background:linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%);
          }
          &.deep-green {
            background:linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%);
          }
          &.deep-purple {
            background:linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%);
          }
          &.deep-yellow {
            background:linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%);
          }
        }
        .icon{
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
        }
        .text{
          position: relative;
          z-index: 1;
        }
      }
      .product-item-info{
        flex-grow: 1;
        overflow: hidden;
        border:1px solid rgba(233,238,242,1);
        border-radius: 0 2px 2px 0;
        display: flex;
        padding: 0px 20px 0px 16px;
        .product-item-info-left{
          flex-grow: 1;
          overflow: hidden;
          margin-right: 50px;
          padding-top: 16px;
          .product-item-title{
            color: #2F333D;
            font-size: 18px;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 14px;
            font-weight: 600;
          }
          .product-item-other{
            display: flex;
            align-items: center;
            color: #91999F;
            font-size: 14px;
            line-height: 1;
            .product-item-depart-date{
              color: #2F333D;
              font-size: 14px;
            }
            .product-item-info-need-days, .product-item-entry-count, .product-item-validity-period, .product-item-entry-stay{
              margin-left: 12px;
              display: flex;
              align-items: center;
              .tips{
                display: inline-block;
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
            }

          }
        }
        .product-item-price-box{
          padding: 16px 0;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          .sale-price{
            font-weight: 600;
            color: #FF8033;
            display: flex;
            align-items: baseline;
            position: relative;
            line-height: 1;
            .symbol{
              font-size: 24px;
            }
            .price{
              font-size: 32px;
            }
            .special-label{
              position: absolute;
              right: 100%;
              top: 50%;
              transform: translateY(-50%);
               width: 47px;
              height: 20px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
          .original-price{
            color: #91999f;
            font-size: 14px;
            margin-top: 8px;
            .price{
              text-decoration: line-through;
            }
          }
        }
      }
    }


  }
}
</style>





// WEBPACK FOOTER //
// src/pages/index/components/index-hot-product.vue